import { useQuery } from '@tanstack/react-query'
import type { SearchProductList } from '@/components/TripActivity/types'
import fetchRecentTripSearches, {
  type ApiMetadata,
  type RequestOptions
} from '@/shared-utils/fetchRecentTripSearches'
import useSeti from './useSeti'

export default function useRecentSearchCard(
  cguid: string,
  apiMetadata: ApiMetadata,
  searchProducts: SearchProductList,
  signedIn: boolean
) {
  const isRecentSearchRelevanceSeti =
    useSeti('HP_RECENTSEARCH_RELEVANCY', true) === 'VARIANT'
  const shouldHideBookedSearches =
    useSeti('HP_PUWYLO_HIDE_BOOKED_SEARCHES', true) === 'VARIANT'

  const requestOptions: RequestOptions = {}

  if (isRecentSearchRelevanceSeti) requestOptions.sortOrder = 'RELEVANCE'
  if (shouldHideBookedSearches) requestOptions.unbookedSelectionsOnly = true

  const { data = [] } = useQuery({
    queryKey: [
      searchProducts,
      cguid,
      apiMetadata,
      signedIn,
      requestOptions,
      'recent-searches'
    ],
    queryFn: () =>
      fetchRecentTripSearches(
        cguid,
        apiMetadata,
        searchProducts,
        signedIn,
        requestOptions
      ),
    staleTime: Infinity
  })

  return data
}
